customElements.get("product-form") ||
  customElements.define(
    "product-form",
    class t extends HTMLElement {
      constructor() {
        super(),
          (this.form = this.querySelector("form")),
          (this.formIdInput = this.form.querySelector("[name=id]")),
          (this.formIdInput.disabled = !1),
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
          (this.cart =
            document.querySelector("cart-notification") ||
            document.querySelector("cart-drawer")),
          (this.submitButton = this.querySelector('[type="submit"]')),
          document.querySelector("cart-drawer") &&
            this.submitButton.setAttribute("aria-haspopup", "dialog"),
          (this.quantityBreaks = document.getElementById(
            `quantity-breaks-${this.dataset.section}`
          )),
          (this.variantInputs = this.form.querySelector(
            ".product-form__variants"
          ));
      }
      onSubmitHandler(t) {
        if (
          (t.preventDefault(),
          "true" === this.submitButton.getAttribute("aria-disabled"))
        )
          return;
        this.handleErrorMessage(),
          this.submitButton.setAttribute("aria-disabled", !0),
          this.submitButton.classList.add("loading"),
          this.querySelector(".loading-overlay__spinner").classList.remove(
            "hidden"
          );
        let e = !1;
        if (
          (this.variantInputs && (this.variantInputs.innerHTML = ""),
          this.quantityBreaks &&
            this.variantInputs &&
            this.quantityBreaks.formVariants.length > 0)
        ) {
          let r = "";
          e = !0;
          for (let s = 0; s < this.quantityBreaks.formVariants.length; s++) {
            let i = this.quantityBreaks.formVariants[s];
            r += `<input type="hidden" name="items[${s}][quantity]" value="${i.quantity}"><input type="hidden" name="items[${s}][id]" value="${i.id}">`;
          }
          this.variantInputs.innerHTML = r;
        }
        var a = fetchConfig("javascript");
        (a.headers["X-Requested-With"] = "XMLHttpRequest"),
          delete a.headers["Content-Type"];
        var n = new FormData(this.form);
        this.cart &&
          (n.append(
            "sections",
            this.cart.getSectionsToRender().map((t) => t.id)
          ),
          n.append("sections_url", window.location.pathname),
          this.cart.setActiveElement(document.activeElement)),
          e && (n.delete("id"), n.delete("quantity")),
          (a.body = n),
          (this.skipCart = !1),
          this.form.querySelector("[name=id]").dataset.skipCart &&
            "true" === this.form.querySelector("[name=id]").dataset.skipCart &&
            (this.skipCart = !0),
          fetch(`${routes.cart_add_url}`, a)
            .then((t) => t.json())
            .then((t) => {
              if (t.status) {
                this.handleErrorMessage(t.description);
                let e = this.submitButton.querySelector(".sold-out-message");
                if (!e) return;
                this.submitButton.setAttribute("aria-disabled", !0),
                  this.submitButton
                    .querySelector("span")
                    .classList.add("hidden"),
                  e.classList.remove("hidden"),
                  (this.error = !0);
                return;
              }
              const monsterActive = !!document.querySelector('script[src*="/cart_renderer."]');
              function tryOpenCart(retryInterval = 500, maxRetries = 20) {
                let attempts = 0;
          
                const intervalId = setInterval(() => {
                    if (typeof window.monster_refresh === 'function') {
                        clearInterval(intervalId);
                        monster_refresh();
                    } else if (++attempts >= maxRetries) {
                        clearInterval(intervalId);
                    }
                }, retryInterval);
              }
          
              if (monsterActive) {
                return tryOpenCart();
              }
              if (this.skipCart) {
                window.location = "/checkout";
                return;
              }
              if (!this.cart) {
                window.location = window.routes.cart_url;
                return;
              }
              this.error ||
                publish(PUB_SUB_EVENTS.cartUpdate, { source: "product-form" }),
                (this.error = !1);
              let r = this.closest("quick-add-modal");
              r
                ? (document.body.addEventListener(
                    "modalClosed",
                    () => {
                      setTimeout(() => {
                        this.cart.renderContents(t);
                      });
                    },
                    { once: !0 }
                  ),
                  r.hide(!0))
                : this.cart.renderContents(t);
            })
            .catch((t) => {
              console.error(t);
            })
            .finally(() => {
              this.submitButton.classList.remove("loading"),
                this.cart &&
                  this.cart.classList.contains("is-empty") &&
                  this.cart.classList.remove("is-empty"),
                this.error ||
                  this.submitButton.removeAttribute("aria-disabled"),
                this.querySelector(".loading-overlay__spinner").classList.add(
                  "hidden"
                );
            });
      }
      handleErrorMessage(t = !1) {
        (this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper")),
          this.errorMessageWrapper &&
            ((this.errorMessage =
              this.errorMessage ||
              this.errorMessageWrapper.querySelector(
                ".product-form__error-message"
              )),
            this.errorMessageWrapper.toggleAttribute("hidden", !t),
            t && (this.errorMessage.textContent = t));
      }
    }
  );
